export default __webpack_public_path__ + "static/media/flag.85b7f971.svg";